export enum UIWorkflowValidierung {
  WORKFLOW_VALIDIERUNG_ALLES_GLEICHZEITIG = 'AllesGleichzeitig',
  WORKFLOW_VALIDIERUNG_SEQUENZIELL = 'Sequenziell',
}
